import {
  createStyles,
  TableCell,
  TableRow,
  Theme,
  withStyles,
} from '@material-ui/core';

/**
 * Composant de cellule de tableau personnalisé pour le CRM
 * 
 * Styles appliqués :
 * - En-tête : fond noir avec texte blanc
 * - Corps : police de taille 14px
 * 
 * @param theme Thème Material-UI
 * @returns Styles CSS pour les cellules de tableau
 */
export const CrmTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);

/**
 * Composant de ligne de tableau personnalisé pour le CRM
 * 
 * Styles appliqués :
 * - Alternance de couleurs pour les lignes paires/impaires
 * - Fond hover pour l'interaction utilisateur
 * 
 * @param theme Thème Material-UI
 * @returns Styles CSS pour les lignes de tableau
 */
export const CrmTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(even)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }),
)(TableRow);

/**
 * Composant de cellule de tableau compacte pour le CRM
 * 
 * Styles appliqués :
 * - Padding réduit pour un affichage plus compact
 * - Hérite des styles de CrmTableCell
 * 
 * @param theme Thème Material-UI
 * @returns Styles CSS pour les cellules compactes
 */
export const SmallTableCell = withStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0, 2),
    },
  }),
)(CrmTableCell as any);
